import { useTranslations } from 'next-intl';
import { useCallback, useState } from 'react';

import { BaseFieldProps } from '@/fo/ui/kit/field/base';
import { UiKitInputBase } from '@/fo/ui/kit/input/base';
import { Option } from '@/fo/ui/kit/listbox/base';
import { UiKitSelectBase } from '@/fo/ui/kit/select/base';

import { UserInfo } from '../../types';

import { styles } from './AboutUserSection.styles';

export interface AboutUserSectionProps {
  skinTypes: Option[];
  skinProblems: Option[];
  getFieldProps: (name: string) => BaseFieldProps;
  userInfo?: UserInfo;
}

export function AboutUserSection({
  skinTypes,
  skinProblems,
  getFieldProps,
  userInfo
}: AboutUserSectionProps) {
  const slots = styles();
  const t = useTranslations('review.form.aboutUser');

  const [skinType, setSkinType] = useState<Option | null>(
    userInfo?.skinType
      ? {
          value: userInfo?.skinType,
          label:
            skinTypes.find((skinType) => skinType.value === userInfo?.skinType)
              ?.label ?? ''
        }
      : null
  );

  const [skinProblem, setSkinProblem] = useState<Option | null>(
    userInfo?.skinProblem
      ? {
          value: userInfo?.skinProblem,
          label:
            skinProblems.find(
              (skinProblem) => skinProblem.value === userInfo?.skinProblem
            )?.label ?? ''
        }
      : null
  );

  const handleSkinTypeChange = useCallback((option: Option | null) => {
    setSkinType(option);
  }, []);

  const handleSkinProblemChange = useCallback((option: Option | null) => {
    setSkinProblem(option);
  }, []);

  return (
    <div className={slots.base()}>
      <div className={slots.general()}>
        <UiKitInputBase
          label={t('name.label')}
          className={slots.name()}
          placeholder={t('name.placeholder')}
          value={userInfo?.name}
          {...getFieldProps('name')}
          autoComplete="name"
          required
        />
        <UiKitInputBase
          min={1}
          max={100}
          label={t('age.label')}
          className={slots.age()}
          type="number"
          placeholder={t('age.placeholder')}
          value={userInfo?.age}
          autoComplete="age"
          {...getFieldProps('age')}
        />
      </div>
      <UiKitInputBase
        name="email"
        label={t('email.label')}
        type="email"
        autoComplete="email"
        value={userInfo?.email}
        placeholder={t('email.placeholder')}
        {...getFieldProps('email')}
        readOnly={Boolean(userInfo?.email)}
        required
      />
      <UiKitSelectBase
        label={t('skinType.label')}
        placeholder={t('skinType.label')}
        options={skinTypes}
        {...getFieldProps('skinType')}
        onChange={handleSkinTypeChange}
        selected={skinType}
      />
      <UiKitSelectBase
        label={t('problem.label')}
        placeholder={t('problem.label')}
        options={skinProblems}
        {...getFieldProps('skinProblem')}
        onChange={handleSkinProblemChange}
        selected={skinProblem}
      />
    </div>
  );
}
